var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"niste-clan"},[_c('div',[_vm._v(_vm._s(_vm.$t("coming_soon.text")))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("coming_soon.go_back")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }